import React, { useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL, ENDPOINTS } from '../../constants/api';
import axios from 'axios';
const PosPendingInvoice = () => {
    const [data,setData]=useState([]);
    const [loading, setLoading] = useState(false);
    const [company, setCompany] = useState([]);
  const styles = {
    container: {
      fontFamily: 'Roboto',
      width: '280px', // XP-80C printer size
      padding: '8px',
      margin: '0 auto',
      fontSize: '13px',
      fontWeight:"bold",
      background: 'white',
      color: 'black',
    },
    center: {
      textAlign: 'center',
      marginBottom: '6px',
    },
    divider: {
      borderTop: '1px dashed #000',
      margin: '4px 0',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid black', 
    },
    thtd: {
       fontWeight:550,
      textAlign: 'left',
      padding: '2px 4px',
      border: '2px solid black', 
    },
    headerGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '2px',
      marginBottom: '6px',
    },
    rightText: {
      textAlign: 'right',
      margin: '0 0 4px 0',
    },
  };
  
  const { route, id } = useParams();


    useEffect(() => {
   setLoading(true);
    const url = `${API_URL}/${ENDPOINTS.SYS}/posInvoice/${route}/0`;
    
    // console.log('url:', url);
    const posInvoice = async () => {
      try {
         const response2 = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );

        // console.log(response.data.company);
        setCompany(response2.data.company[0]);
        const response = await axios.get(url);
        setData(response.data.data);
        console.log("api res: ",response.data);
        setData(response.data.data);
        setLoading(false)
        console.log("api res: ",response.data);
        console.log("api res:", response.data);


       

      } catch (error) {
        console.error('Error fetching data:', error);
       
      }
    };

    posInvoice();
     // Call every 15 seconds
    const interval = setInterval(posInvoice, 15000); // 15000 ms = 15 sec

    // Cleanup on component unmount or route change
    return () => clearInterval(interval);
  }, [route]);

  useEffect(() => {
    if (!loading && data && data.length>0) {
      // Delay to ensure render finishes before print
      setTimeout(() => {
        window.print();
      }, 300);
    }
  }, [loading, data]);

  // Extract sections
  const header = data?.find(d => d.title === 'header')?.fields || {};
  const itemsData = data?.find(d => d.title === 'items');
const items = Array.isArray(itemsData?.table)
  ? itemsData.table
  : itemsData?.fields
  ? [itemsData.fields]
  : [];

  const payment = data?.find(d => d.title === 'payment')?.fields || {};
  
  if(data && data.lenth>0){
     window.print()
    }
  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.center}>
        <h3 style={{ margin: 0,fontSize:"14px" ,fontWeight:"bold"}}>{company?.name}</h3>
      </div>

       <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '6px' }}>
  {Object.entries(header).map(([key, value], i) => {
    const [label, col] = key.split('~');
    const width = col ? `${(col / 12) * 100}%` : '50%'; // default col-6
    
    return (
      
      <div key={i} style={{ width, padding: '2px 0' }}>
        <strong>{label}:</strong> {value}
      </div>
    );
  })}
</div>

      <div  />

      {/* Items Table */}
      <table style={styles.table}>
        <thead>
          <tr>
            {items.length > 0 &&
              Object.keys(items[0]).map((head, i) => (
                <th key={i} style={styles.thtd}>{head}</th>
              ))}
          </tr>
        </thead>
        <tbody>
          {items.map((row, i) => (
            <tr key={i}>
              {Object.values(row).map((val, j) => (
                <td key={j} style={styles.thtd}>{val}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div  />

      {/* Payment summary aligned right */}
      <div>
        {Object.entries(payment).map(([key, value], i) => (
          <p key={i} style={styles.rightText}>
            <strong>{key}:</strong> {value}
          </p>
        ))}
        {payment.total && payment.paid && (
          <p style={styles.rightText}>
            <strong>Change:</strong>{' '}
            {(parseFloat(payment.paid) - parseFloat(payment.total)).toFixed(2)}
          </p>
        )}
      </div>

      {/* Footer */}
      <div style={{ ...styles.center, marginTop: '10px' }}>
        <p style={{ margin: 0 }}>Thanks for your order!</p>
        <p style={{ margin: 0 }}>Powered by KTC</p>
      </div>
    </div>
  );
};

export default PosPendingInvoice;
